export const COOKIE_HIDE_REFERRAL_BANNER = 'hideReferralBanner'
